import React, { useState, useContext } from 'react';
import WalletContext from '../../context/WalletContext';
import { VENUES } from './constants';
import { switchChain, chainName } from '../../utils/chainSwitch';
import HyperliquidPanel from './HyperliquidPanel';
import GmxPanel from './GmxPanel';
import CanborsaPanel from './CanborsaPanel';

export default function TradeController({ venue, setVenue }) {
  // The raw EIP-1193 provider of the wallet we are actually connected to.
  // switchChain must target that, not window.ethereum — with two extensions
  // installed the global is often the other wallet, and asking it to switch
  // does nothing to this session.
  const { provider, chainId, connected } = useContext(WalletContext);
  const rawProvider = provider?.provider || null;
  // Each venue has its own market format — keep them independent
  const [hlMarket,       setHlMarket]       = useState('BTC');
  const [gmxMarket,      setGmxMarket]      = useState('BTC/USD');
  const [canborsaMarket, setCanborsaMarket] = useState('BTC/USD');

  return (
    <div className="trade-controller">

      {/* Venue selector */}
      <div className="tc-venue-bar">
        {VENUES.map(v => (
          <button
            key={v.id}
            className={`tc-venue-btn ${venue === v.id ? 'active' : ''} ${v.disabled ? 'disabled' : ''}`}
            onClick={async () => {
              if (v.disabled) return;
              setVenue(v.id);
              // Ask the wallet for this venue's chain. Clicking the tab is the
              // user action, so a wallet prompt here is expected — and without
              // it GMX mounts on whatever chain HYPE left set and shows nothing.
              if (v.chainId) {
                // Log every outcome, not just failures — a switch that silently
                // does nothing is indistinguishable from one that worked.
                const r = await switchChain(v.chainId, rawProvider);
                console.log('[TradeController] switch ->', v.chainId,
                  r.ok ? 'ok' : `FAILED: ${r.reason}`,
                  r.error?.message || '', '| hadProvider:', Boolean(rawProvider));
              }
            }}
            title={v.disabled ? 'Coming soon' : v.label}
          >
            <span className="tc-venue-label">{v.label}</span>
            {v.chain && <span className="tc-venue-chain">{v.chain}</span>}
          </button>
        ))}
      </div>

      {/*
        Network state. The app previously gave no indication of which chain the
        wallet was on, so a venue sitting on the wrong network looked identical
        to one with nothing to show — every on-chain read just returned empty.
      */}
      {connected && (() => {
        const selected = VENUES.find(v => v.id === venue);
        const mismatch = selected?.chainId && chainId && chainId !== selected.chainId;
        return (
          <div
            className={`tc-net-status ${mismatch ? 'mismatch' : 'ok'}`}
            onClick={mismatch ? async () => {
              const r = await switchChain(selected.chainId, rawProvider);
              console.log('[TradeController] banner switch ->', r.ok ? 'ok' : r.reason);
            } : undefined}
          >
            {mismatch
              ? `WRONG NETWORK — wallet on ${chainName(chainId)}, ${selected.label} needs ${chainName(selected.chainId)} · CLICK TO SWITCH`
              : `NETWORK: ${chainName(chainId)}`}
          </div>
        );
      })()}

      {/* Venue panel */}
      <div className="tc-panel">
        {venue === 'hyperliquid' && <HyperliquidPanel market={hlMarket}       setMarket={setHlMarket} />}
        {venue === 'gmx'         && <GmxPanel         market={gmxMarket}      setMarket={setGmxMarket} />}
        {venue === 'canborsa'    && <CanborsaPanel     market={canborsaMarket} setMarket={setCanborsaMarket} />}
      </div>

    </div>
  );
}
